import { AssetsFilter } from "@/controls/assetsFilter/AssetsFilter";
import {
	ShiftDayNavigatorControl,
	getShiftByParameters,
	useMesfRealtime,
	useShiftNavigator,
} from "@dexteel/mesf-core";
import { Grid, Paper, makeStyles } from "@material-ui/core";
import { get } from "lodash-es";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDebounce } from "use-debounce";
import { useLogbookContext } from "../../context/logbookContext";
import { getEntries } from "../../repository/LogbookRepository";
import { SearchFilter } from "./searchFilter";

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		marginTop: 10,
	},
	paper: {
		padding: theme.spacing(2),
		marginBottom: theme.spacing(2),
		borderRadius: "0.75rem",
	},
}));

type Props = {
	searchEntries: Function;
};

export const Filters = ({ searchEntries }: Props) => {
	const { shiftInfo, getShiftDataFromAPI } = useShiftNavigator();
	const {
		state: {
			FilterParameters: { AssetId, SearchText },
		},
		actions: { setFilterAssetId, setFilterSearchText, setEntriesList },
	} = useLogbookContext();
	const navigate = useNavigate();

	const [debouncedSearchText] = useDebounce(SearchText, 400);

	useEffect(() => {
		searchEntries();
		navigate("/logbook-entry");
	}, [shiftInfo, AssetId]);

	useEffect(() => {
		(async () => {
			const res = await getShiftDataFromAPI(null, 0);
		})();
	}, []);

	useEffect(() => {
		let isValid = true;
		const getData = async () => {
			if (shiftInfo?.CurrentShiftId) {
				const res = await getEntries(
					null,
					SearchText,
					AssetId,
					shiftInfo?.CurrentShiftId || null,
				);

				if (isValid && res.ok) {
					const rowsSource = get(res, "data.tables[0]", []);
					setEntriesList(rowsSource.rows);
				}
			}
		};

		getData();

		return () => {
			isValid = false;
		};
	}, [AssetId, debouncedSearchText, shiftInfo?.CurrentShiftId]);

	useMesfRealtime({
		onReceiveMessage: (author, message) => {
			if (message.replaceAll("[", "").replaceAll("]", "") == "LB.GetEntries") {
				const getData = async () => {
					const res = await getEntries(
						null,
						SearchText,
						AssetId,
						shiftInfo?.CurrentShiftId || null,
					);

					if (res.ok) {
						const rowsSource = get(res, "data.tables[0]", []);
						setEntriesList(rowsSource.rows);
					}
				};
				getData();
			}
		},
	});

	return (
		<Paper elevation={1} style={{ padding: 8 }}>
			<Grid container spacing={1}>
				<Grid item xs={12} container spacing={2} alignItems="center">
					<Grid item xs={12} md={10} style={{ maxWidth: 450 }}>
						<ShiftDayNavigatorControl preventInit />
					</Grid>
					<Grid item xs={12} md={2}>
						<AssetsFilter
							title="Asset"
							value={AssetId}
							onChange={(newValue) => {
								setFilterAssetId(newValue);
							}}
						/>
					</Grid>
				</Grid>
				<Grid item xs={12}>
					<SearchFilter value={SearchText} onChange={setFilterSearchText} />
				</Grid>
			</Grid>
		</Paper>
	);
};
